import React from "react";
import { Button, Modal } from "react-bootstrap";
import Resources from "../../types/Resources";
import useDeleteCompanyDepartmentModal from "./useDeleteCompanyDepartmentModal";
import LoadingSpinner from "../Common/LoadingSpinner";

export type DeleteCompanyDepartmentModalProps = {
    resources: Resources;
    show: boolean;
    departmentId: number;
    onHide: () => void;
    onDepartmentDeleted: () => void;
};

function DeleteCompanyDepartmentModal(props: DeleteCompanyDepartmentModalProps) {
    const { resources } = props;

    const modalContent = useDeleteCompanyDepartmentModal(props);

    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{resources.get("DeleteCompanyDepartment")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {modalContent.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <p>{resources.get("ConfirmDeleteFollowingCompanyDepartment")}</p>
                        <p>
                            <strong>{modalContent.department?.name}</strong>
                        </p>
                        <div className="mt-3 w-100 d-flex justify-content-evenly gap-3">
                            <Button
                                variant="danger"
                                onClick={modalContent.handleDeleteCompanyDepartmentAsync}
                                disabled={modalContent.deleteInProgress}
                                className="w-100"
                            >
                                {resources.get("YesDeleteCompanyDepartment")}
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={props.onHide}
                                disabled={modalContent.deleteInProgress}
                                className="w-100"
                            >
                                {resources.get("Cancel")}
                            </Button>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default DeleteCompanyDepartmentModal;
